import { CrmTasksPage } from './CrmTasksPage';

const CRM_V2_ENABLED = (import.meta.env.VITE_CRM_V2_ENABLED ?? '').toLowerCase() === 'true';

export function TasksPage() {
  if (CRM_V2_ENABLED) {
    return <CrmTasksPage />;
  }

  return (
    <>
      <header className="mb-8">
        <h2 className="text-2xl font-semibold text-foreground">Tasks</h2>
        <p className="mt-1 text-sm text-muted-foreground">Snoozed and scheduled follow-ups</p>
      </header>

      <div className="grid grid-cols-3 gap-4 mb-8">
        {[
          { label: 'Pending Follow-ups', value: '12' },
          { label: 'Scheduled Campaigns', value: '3' },
          { label: 'Completed (Week)', value: '45' },
        ].map((stat) => (
          <div key={stat.label} className="rounded-xl border border-border bg-card p-5">
            <span className="text-sm text-muted-foreground">{stat.label}</span>
            <p className="mt-2 text-2xl font-semibold text-foreground">{stat.value}</p>
          </div>
        ))}
      </div>

      <h3 className="mb-4 text-lg font-medium text-foreground">Due Soon</h3>
      <div className="space-y-3">
        {[1, 2].map((i) => (
          <div
            key={i}
            className="flex items-center justify-between rounded-lg border border-border bg-card p-4"
          >
            <div>
              <p className="font-medium text-foreground">Follow up with billing issue {i}</p>
              <p className="mt-1 text-xs text-muted-foreground">Due in 2 hours • assigned to you</p>
            </div>
            <button className="rounded bg-secondary px-3 py-1 text-sm text-secondary-foreground transition-colors hover:bg-secondary/80">
              Start Task
            </button>
          </div>
        ))}
      </div>
    </>
  );
}
